<template>
    <section class="rtb-form-section" data-field="budget_total_limit">
        <fieldset v-if="showBudget" class="rtb-form-fieldset">
            <legend>Общие лимиты</legend>
            <p v-if="!hasLimit" class="field__hint">Нужен хотя бы один из четырёх лимитов — общий или дневной, бюджет или показы.</p>
            <div class="rtb-form-section__row">
                <div class="field">
                    <label class="field__label" for="rtb-form-budget-total">Лимит бюджета, ₸</label>
                    <input
                        id="rtb-form-budget-total"
                        v-model.number="form.budget_total_limit"
                        type="number"
                        min="0"
                        step="0.01"
                        class="form-input"
                        placeholder="0 = без лимита"
                        :disabled="disabled"
                        :class="{ 'is-invalid': errors.budget_total_limit }"
                    />
                </div>
                <div class="field">
                    <label class="field__label" for="rtb-form-impr-total">Лимит показов</label>
                    <input
                        id="rtb-form-impr-total"
                        v-model.number="form.impr_total_limit"
                        type="number"
                        min="0"
                        class="form-input"
                        placeholder="0 = без лимита"
                        :disabled="disabled"
                    />
                </div>
            </div>
            <p v-if="errors.budget_total_limit" class="field__error">{{ errors.budget_total_limit }}</p>
        </fieldset>

        <fieldset class="rtb-form-fieldset">
            <legend>{{ showBudget ? 'Дневные лимиты' : 'Лимиты показов' }}</legend>
            <label v-if="showBudget" class="rtb-form-check">
                <input v-model="distributeEvenly" type="checkbox" :disabled="disabled" />
                <span>
                    Распределить равномерно
                    <span v-if="distributeEvenly && days > 0" class="field__hint">{{ days }} дн.</span>
                    <span v-else-if="distributeEvenly" class="field__error">Укажите даты кампании</span>
                </span>
            </label>
            <div class="rtb-form-section__row">
                <div v-if="showBudget" class="field">
                    <label class="field__label" for="rtb-form-budget-daily">Дневной бюджет, ₸</label>
                    <input
                        id="rtb-form-budget-daily"
                        v-model.number="form.budget_daily_limit"
                        type="number"
                        min="0"
                        step="0.01"
                        class="form-input"
                        placeholder="Пусто = без лимита"
                        :disabled="disabled || distributeEvenly"
                    />
                </div>
                <div class="field">
                    <label class="field__label" for="rtb-form-impr-daily">{{ showBudget ? 'Дневной лимит показов' : 'Лимит показов (общий)' }}</label>
                    <input
                        v-if="showBudget"
                        id="rtb-form-impr-daily"
                        v-model.number="form.impr_daily_limit"
                        type="number"
                        min="0"
                        class="form-input"
                        placeholder="Пусто = без лимита"
                        :disabled="disabled || distributeEvenly"
                    />
                    <input
                        v-else
                        id="rtb-form-impr-total-only"
                        v-model.number="form.impr_total_limit"
                        type="number"
                        min="0"
                        class="form-input"
                        placeholder="0 = без лимита"
                        :disabled="disabled"
                    />
                </div>
                <div v-if="!showBudget" class="field">
                    <label class="field__label" for="rtb-form-impr-daily-only">Дневной лимит показов</label>
                    <input
                        id="rtb-form-impr-daily-only"
                        v-model.number="form.impr_daily_limit"
                        type="number"
                        min="0"
                        class="form-input"
                        placeholder="Пусто = без лимита"
                        :disabled="disabled"
                    />
                </div>
            </div>
        </fieldset>
    </section>
</template>

<script setup>
defineProps({
    form: { type: Object, required: true },
    errors: { type: Object, default: () => ({}) },
    disabled: { type: Boolean, default: false },
    showBudget: { type: Boolean, default: true },
    hasLimit: { type: Boolean, default: true },
    days: { type: Number, default: 0 },
});

const distributeEvenly = defineModel('distributeEvenly', { type: Boolean, default: false });
</script>
